import _styled from "styled-components";
const _excluded = ["message", "id", "autoDismiss", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useReducer, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { CONTEXT_NAMES, getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import theme from '@adsk/alloy-react-theme';
import Notification from '../Notification';
const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
const NOTIFICATION_DISMISS_TIMEOUT = 6;
function notificationReducer(notifications, action) {
  switch (action.type) {
    case REMOVE_NOTIFICATION:
      return notifications.filter(notification => notification.id !== action.id);
    case SHOW_NOTIFICATION:
      return [...notifications, ...(action.payload ? [action.payload] : [])];
    default:
      console.error("NotificationsProvider - Unknown action type: ".concat(action.type));
      return notifications;
  }
}
const generateRandomID = () => Math.random().toString(36).substring(2, 15);
const NotificationsContext = getOrCreateGlobalContext(CONTEXT_NAMES.NotificationsContext);
export const useNotifications = () => useContextWithValidation(NotificationsContext, {
  hook: 'useNotifications',
  provider: 'NotificationsProvider'
});
export function NotificationsProvider(_ref) {
  let {
    children
  } = _ref;
  const [notifications, dispatch] = useReducer(notificationReducer, []);
  const removeNotification = useCallback(id => dispatch({
    type: REMOVE_NOTIFICATION,
    id
  }), []);
  const showNotification = useCallback(notification => {
    let timeout;
    const id = notification.id || generateRandomID();
    const dismissWrapper = () => {
      removeNotification(id);
      clearTimeout(timeout);
      if (notification.onDismiss && typeof notification.onDismiss === 'function') {
        notification.onDismiss();
      }
    };
    const hasPromise = notification.asyncOperation && typeof notification.asyncOperation.then === 'function';
    const finalNotification = _objectSpread(_objectSpread({
      autoDismiss: NOTIFICATION_DISMISS_TIMEOUT,
      dismissible: !hasPromise
    }, notification), {}, {
      id,
      onDismiss: dismissWrapper
    });
    const configureTimeOut = () => setTimeout(finalNotification.onDismiss, finalNotification.autoDismiss * 1000);
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: finalNotification
    });
    if (hasPromise) {
      finalNotification.asyncOperation && finalNotification.asyncOperation.then(() => {
        timeout = configureTimeOut();
      }).catch(() => {
        timeout = configureTimeOut();
      });
    } else if (finalNotification.dismissible !== false && finalNotification.autoDismiss > 0) {
      timeout = configureTimeOut();
    }
    return {
      id,
      removeNotification: () => removeNotification(id)
    };
  }, [removeNotification]);
  const contextValue = useMemo(() => ({
    showNotification,
    removeNotification
  }), [showNotification, removeNotification]);
  return /*#__PURE__*/React.createElement(NotificationsContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      position: 'fixed',
      zIndex: theme.zIndex.notification,
      right: 16,
      top: 16 + 72 /* header height is 72 */
    }]
  }, notifications.map(notification => {
    const {
        message,
        id,
        // this is unused in the Notification component
        autoDismiss: _ignoredAutoDismiss,
        style
      } = notification,
      rest = _objectWithoutProperties(notification, _excluded);
    return /*#__PURE__*/React.createElement(Notification, _extends({}, rest, {
      key: id,
      style: [{
        marginBottom: theme.spacing.XS
      }, style]
    }), message);
  })));
}
NotificationsProvider.propTypes = {
  children: PropTypes.any
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "context___StyledDiv",
  componentId: "sc-n8tehp-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=context.js.map